import {Accordion, AccordionDetails, AccordionSummary, Input, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

export const StyledAccordion = styled(Accordion)(({theme}) => ({
  width: '100%',
  // padding: theme.spacing(2, 0, 2, 0),
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiPaper-root': {
    padding: 0
  },
  '&:before': {
    display: 'none'
  }
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(0, 4, 0, 4),
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  }
}));

export const StyledAccordionPointsSummary = styled(AccordionSummary)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(0, 4, 0, 4),
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  [theme.breakpoints.down('md')]: {
    height: theme.spacing(10)
  }
}));

export const StyledAccordionPointsDetailsWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(0, 4, 3, 4),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(1),
    padding: theme.spacing(0, 4, 2, 4)
  }
}));

export const StyledAccordionPointsDetails = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(10),
  padding: theme.spacing(0, 0, 1, 0),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(3)
  }
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(0, 4, 2, 4)
}));

export const StyledInput = styled(Input)(({theme}) => ({
  minWidth: theme.spacing(21),
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none'
  },
  '& input[type=number]': {
    MozAppearance: 'textfield'
  }
}));

export const AccordionSummaryUpperHeaderStyled = styled(Box)(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(1)
}));

export const PointsLeftStyled = styled(Box)(({theme}) => ({
  display: 'inline-flex',
  gap: theme.spacing(1)
}));

export const PointsRightStyled = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center'
}));

export const CardStyled = styled(Box)(({theme}) => ({
  display: 'inline-flex',
  gap: theme.spacing(1),
  color: theme.palette.grey[300]
}));

export const AccordionSummaryLowerHeaderStyled = styled(Box)(() => ({
  display: 'inline-flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const VoucherWarningStyled = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.grey[300]
}));

export const CardNumStyled = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.caption.fontSize
}));

export const StyledLink = styled('a')<{isActive?: boolean}>(({theme, isActive}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: isActive ? theme.palette.primary.main : theme.palette.secondary.dark,
  cursor: isActive ? 'pointer' : 'inherit',
  textDecoration: isActive ? 'underline' : 'none',
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.caption.fontSize,
    width: theme.spacing(15)
  }
}));
